export const LEGALITYASSET_LOADING = "LEGALITYASSET_LOADING";
export const LEGALITYASSET_RESET = "LEGALITYASSET_RESET";
export const GET_LEGALITYASSET = "GET_LEGALITYASSET";
export const GET_LEGALITYASSET_SUCCESS = "GET_LEGALITYASSET_SUCCESS";
export const GET_LEGALITYASSET_FAIL = "GET_LEGALITYASSET_FAIL";
export const DELETE_LEGALITYASSET = "DELETE_LEGALITYASSET"
export const DELETE_LEGALITYASSET_SUCCESS = "DELETE_LEGALITYASSET_SUCCESS"
export const DELETE_LEGALITYASSET_FAIL = "DELETE_LEGALITYASSET_FAIL"
export const UPDATE_LEGALITYASSET = "UPDATE_LEGALITYASSET"
export const UPDATE_LEGALITYASSET_SUCCESS = "UPDATE_LEGALITYASSET_SUCCESS"
export const UPDATE_LEGALITYASSET_FAIL = "UPDATE_LEGALITYASSET_FAIL"
export const ADD_NEW_LEGALITYASSET = "ADD_NEW_LEGALITYASSET"
export const ADD_LEGALITYASSET_SUCCESS = "ADD_LEGALITYASSET_SUCCESS"
export const ADD_LEGALITYASSET_FAIL = "ADD_LEGALITYASSET_FAIL"